
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"17","height":"22","viewBox":"0 0 78.3 97"}},[_c('path',{attrs:{"d":"M39 .4C24.1.5 12.1 12.6 12.2 27.5v13.1H.9v55h76.2v-55H65.8V27.5C65.9 12.6 53.9.5 39 .4zM18.2 27.5C18.2 16 27.5 6.7 39 6.7S59.8 16 59.8 27.5v13.1H18.2V27.5zm53 62.1H6.9v-43h64.2l.1 43z"}}),_c('path',{attrs:{"d":"M36 72.6v8.1h6v-8.1c5.3-1.7 8.2-7.3 6.5-12.5-1.7-5.3-7.3-8.2-12.5-6.5-5.3 1.7-8.2 7.3-6.5 12.5.9 3.1 3.4 5.5 6.5 6.5zM39 59c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      